import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import DaoVotingList from 'pages/dao-voting'
import DaoVotingDetail from 'pages/dao-voting/detail'
import { PAGES } from 'routes/index'

export const daoRoutes: RouteObject[] = [
  {
    path: PAGES.DAO_VOTING,
    element: (
      <PrivateRoute feature={FEATURE.DAO}>
        <DaoVotingList />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.DAO_VOTING_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.DAO}>
        <DaoVotingDetail />
      </PrivateRoute>
    ),
  },
]
